export default "__VITE_ASSET__CJznSLHq__"